/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../../widgets/GridSectionHeader";
import GridTextfield from "../../../widgets/GridTextfield";

import {
  valudateTextfield2,
  validateCurrencyField3,
  removeCommaFromCurrency,
  convertLocaleString,
} from "../../../../utils/fieldValidator.js";

//DATA SLICE - REDUCER
import {
  updateCashAsset,
  updatePersonalUseAsset,
  updateInvestmentAsset,
} from "../../../../states/slcAssetLiability.js";

var savingsError = "";
var fixedDepositError = "";
var otherCashDescError = "";
var otherCashAmountError = "";

var residencePropertyAmtError = "";
var motorVehiclesAmtError = "";
var otherPersonalAssetsDescError = "";
var otherPersonalAssetsAmtError = "";

var unitTrustAmtError = "";
var stocksAmtError = "";
var bondsAmtError = "";
var ilpAmtError = "";
var businessInterestAmtError = "";
var insuranceEndowmentAmtError = "";
var cpfOriginalAccountAmtError = "";
var cpfSavingsAccountAmtError = "";
var cpfMedisaveAmtError = "";
var srsAmtError = "";

//Property List Error
var investmentPropertyAmtError1 = "";
var investmentPropertyAmtError2 = "";

//Other investment List Error
var otherInvestmentDescError1 = "";
var otherInvestmentAmtError1 = "";
var otherInvestmentDescError2 = "";
var otherInvestmentAmtError2 = "";

//TRUE - WHEN COMPONENT IS VALID
var validAsset = true;

export function getAssetValidity() {
  return validAsset;
}

export default function Assets({ setEnableNext }) {
  const assets = useSelector((state) => state.assetliability);

  const [isValid, setIsValid] = useState(false);

  const [savings, setSavings] = useState(assets.savings);
  const [fixedDeposit, setFixedDeposit] = useState(assets.fixedDeposit);
  const [otherCashDesc, setOtherCashDesc] = useState(assets.otherCashDesc);
  const [otherCashAmount, setOtherCashAmount] = useState(assets.otherCashAmount);
  const [totalCashAsset, setTotcalCashAsset] = useState(assets.totalCashAsset);

  const [residencePropertyAmt, setResidencePropertyAmt] = useState(assets.residencePropertyAmt);
  const [motorVehiclesAmt, setMotorVehiclesAmt] = useState(assets.motorVehiclesAmt);
  const [otherPersonalAssetsDesc, setOtherPersonalAssetsDesc] = useState(assets.otherPersonalAssetsDesc);
  const [otherPersonalAssetsAmt, setOtherPersonalAssetsAmt] = useState(assets.otherPersonalAssetsAmt);
  const [totalPersonalUseAsset, setPersonalUseAsset] = useState(assets.totalPersonalUseAsset);

  const [unitTrustAmt, setUnitTrustAmt] = useState(assets.unitTrustAmt);
  const [stocksAmt, setStocksAmt] = useState(assets.stocksAmt);
  const [bondsAmt, setBondsAmt] = useState(assets.bondsAmt);
  const [ilpAmt, setIlpAmt] = useState(assets.ilpAmt);
  const [businessInterestAmt, setBusinessInterestAmt] = useState(assets.businessInterestAmt);
  const [insuranceEndowmentAmt, setInsuranceEndowmentAmt] = useState(assets.insuranceEndowmentAmt);
  const [cpfOriginalAccountAmt, setCpfOriginalAccountAmt] = useState(assets.cpfOriginalAccountAmt);
  const [cpfSavingsAccountAmt, setCpfSavingsAccountAmt] = useState(assets.cpfSavingsAccountAmt);
  const [cpfMedisaveAmt, setCpfMedisaveAmt] = useState(assets.cpfMedisaveAmt);
  const [srsAmt, setSrsAmt] = useState(assets.srsAmt);

  //Property List
  const [investmentPropertyAmt1, setInvestmentPropertyAmt1] = useState(assets.investmentPropertyAmt1);
  const [investmentPropertyAmt2, setInvestmentPropertyAmt2] = useState(assets.investmentPropertyAmt2);

  //Other investment List
  const [otherInvestmentDesc1, setOtherInvestmentDesc1] = useState(assets.otherInvestmentDesc1);
  const [otherInvestmentAmt1, setOtherInvestmentAmt1] = useState(assets.otherInvestmentAmt1);
  const [otherInvestmentDesc2, setOtherInvestmentDesc2] = useState(assets.otherInvestmentDesc2);
  const [otherInvestmentAmt2, setOtherInvestmentAmt2] = useState(assets.otherInvestmentAmt2);

  const [totalInvestmentAsset, setInvestmentAsset] = useState(assets.totalInvestmentAsset);

  const dispatch = useDispatch();

  useEffect(() => {
    let total =
      Number(removeCommaFromCurrency(savings)) +
      Number(removeCommaFromCurrency(fixedDeposit)) +
      (otherCashDesc ? Number(removeCommaFromCurrency(otherCashAmount)) : 0);

    total = convertLocaleString(total, "en-US", 2);

    setTotcalCashAsset(total);
    updateRedux("totalCashAsset", total, updateCashAsset);
  }, [savings, fixedDeposit, otherCashDesc, otherCashAmount]);

  useEffect(() => {
    let total =
      Number(removeCommaFromCurrency(residencePropertyAmt)) +
      Number(removeCommaFromCurrency(motorVehiclesAmt)) +
      (otherPersonalAssetsDesc ? Number(removeCommaFromCurrency(otherPersonalAssetsAmt)) : 0);

    total = convertLocaleString(total, "en-US", 2);
    setPersonalUseAsset(total);
    updateRedux("totalPersonalUseAsset", total, updatePersonalUseAsset);
  }, [residencePropertyAmt, motorVehiclesAmt, otherPersonalAssetsDesc, updatePersonalUseAsset]);

  useEffect(() => {
    let total =
      Number(removeCommaFromCurrency(unitTrustAmt)) +
      Number(removeCommaFromCurrency(stocksAmt)) +
      Number(removeCommaFromCurrency(bondsAmt)) +
      Number(removeCommaFromCurrency(ilpAmt)) +
      Number(removeCommaFromCurrency(businessInterestAmt)) +
      Number(removeCommaFromCurrency(insuranceEndowmentAmt)) +
      Number(removeCommaFromCurrency(cpfOriginalAccountAmt)) +
      Number(removeCommaFromCurrency(cpfSavingsAccountAmt)) +
      Number(removeCommaFromCurrency(cpfMedisaveAmt)) +
      Number(removeCommaFromCurrency(srsAmt)) +
      Number(removeCommaFromCurrency(investmentPropertyAmt1)) +
      Number(removeCommaFromCurrency(investmentPropertyAmt2)) +
      (otherInvestmentDesc1 ? Number(removeCommaFromCurrency(otherInvestmentAmt1)) : 0) +
      (otherInvestmentDesc2 ? Number(removeCommaFromCurrency(otherInvestmentAmt2)) : 0);

    total = convertLocaleString(total, "en-US", 2);

    updateRedux("totalInvestmentAsset", total, updateInvestmentAsset);
    setInvestmentAsset(total);
  }, [
    unitTrustAmt,
    stocksAmt,
    bondsAmt,
    ilpAmt,
    businessInterestAmt,
    insuranceEndowmentAmt,
    cpfOriginalAccountAmt,
    cpfSavingsAccountAmt,
    cpfMedisaveAmt,
    srsAmt,
    investmentPropertyAmt1,
    investmentPropertyAmt2,
    otherInvestmentDesc1,
    otherInvestmentAmt1,
    otherInvestmentDesc2,
    otherInvestmentAmt2,
  ]);

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  //COMPONENT ID
  let id = "";

  function handleChange(e, object) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    //TEXTFIELDS
    id = e.target.id;
    validateCashAssets(e, id, input_data);
    validatePersonalUseAssets(e, id, input_data);
    validateInvestmentAssets(e, id, input_data);
    calculateValidity();
  }

  //CASH ASSETS
  function validateCashAssets(e, id, input_data) {
    if (id === "savings") {
      input_data.fieldName = "Savings";
      input_data.fieldVariable = savings;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setSavings(result.value);
        updateRedux("savings", result.value, updateCashAsset);
      } else savingsError = result.errorMessage;
    }

    if (id === "fixedDeposit") {
      input_data.fieldName = "Fixed deposit";
      input_data.fieldVariable = fixedDeposit;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setFixedDeposit(result.value);
        updateRedux("fixedDeposit", result.value, updateCashAsset);
      } else fixedDepositError = result.errorMessage;
    }

    if (id === "otherCashDesc") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = otherCashDesc;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setOtherCashDesc(result.value);
        updateRedux("otherCashDesc", result.value, updateCashAsset);
      } else otherCashDescError = result.errorMessage;
    }

    if (id === "otherCashAmount") {
      input_data.fieldName = "Other cash amount";
      input_data.fieldVariable = otherCashAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setOtherCashAmount(result.value);
        updateRedux("otherCashAmount", result.value, updateCashAsset);
      } else otherCashAmountError = result.errorMessage;
    }
  }

  //PERSSONAL USE ASSETS
  function validatePersonalUseAssets(e, id, input_data) {
    if (id === "residencePropertyAmt") {
      input_data.fieldName = "Residence property value";
      input_data.fieldVariable = residencePropertyAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setResidencePropertyAmt(result.value);
        updateRedux("residencePropertyAmt", result.value, updatePersonalUseAsset);
      } else residencePropertyAmtError = result.errorMessage;
    }

    if (id === "motorVehiclesAmt") {
      input_data.fieldName = "Motor vehicle value";
      input_data.fieldVariable = motorVehiclesAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setMotorVehiclesAmt(result.value);
        updateRedux("motorVehiclesAmt", result.value, updatePersonalUseAsset);
      } else motorVehiclesAmtError = result.errorMessage;
    }

    if (id === "otherPersonalAssetsDesc") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = otherPersonalAssetsDesc;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setOtherPersonalAssetsDesc(result.value);
        updateRedux("otherPersonalAssetsDesc", result.value, updatePersonalUseAsset);
      } else otherPersonalAssetsDescError = result.errorMessage;
    }

    if (id === "otherPersonalAssetsAmt") {
      input_data.fieldName = "Other personal assets";
      input_data.fieldVariable = otherPersonalAssetsAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setOtherPersonalAssetsAmt(result.value);
        updateRedux("otherPersonalAssetsAmt", result.value, updatePersonalUseAsset);
      } else otherPersonalAssetsAmtError = result.errorMessage;
    }
  }

  //INVESTMENT ASSETS
  function validateInvestmentAssets(e, id, input_data) {
    if (id === "unitTrustAmt") {
      input_data.fieldName = "Unit trust";
      input_data.fieldVariable = unitTrustAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setUnitTrustAmt(result.value);
        updateRedux("unitTrustAmt", result.value, updateInvestmentAsset);
      } else unitTrustAmtError = result.errorMessage;
    }

    if (id === "stocksAmt") {
      input_data.fieldName = "Stocks";
      input_data.fieldVariable = stocksAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStocksAmt(result.value);
        updateRedux("stocksAmt", result.value, updateInvestmentAsset);
      } else stocksAmtError = result.errorMessage;
    }

    if (id === "bondsAmt") {
      input_data.fieldName = "Bonds";
      input_data.fieldVariable = bondsAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setBondsAmt(result.value);
        updateRedux("bondsAmt", result.value, updateInvestmentAsset);
      } else bondsAmtError = result.errorMessage;
    }

    if (id === "ilpAmt") {
      input_data.fieldName = "ILPs";
      input_data.fieldVariable = ilpAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setIlpAmt(result.value);
        updateRedux("ilpAmt", result.value, updateInvestmentAsset);
      } else ilpAmtError = result.errorMessage;
    }

    if (id === "businessInterestAmt") {
      input_data.fieldName = "Business interests";
      input_data.fieldVariable = businessInterestAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setBusinessInterestAmt(result.value);
        updateRedux("businessInterestAmt", result.value, updateInvestmentAsset);
      } else businessInterestAmtError = result.errorMessage;
    }

    if (id === "insuranceEndowmentAmt") {
      input_data.fieldName = "Insurance endowment";
      input_data.fieldVariable = insuranceEndowmentAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setInsuranceEndowmentAmt(result.value);
        updateRedux("insuranceEndowmentAmt", result.value, updateInvestmentAsset);
      } else insuranceEndowmentAmtError = result.errorMessage;
    }

    if (id === "cpfOriginalAccountAmt") {
      input_data.fieldName = "Original account";
      input_data.fieldVariable = cpfOriginalAccountAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setCpfOriginalAccountAmt(result.value);
        updateRedux("cpfOriginalAccountAmt", result.value, updateInvestmentAsset);
      } else cpfOriginalAccountAmtError = result.errorMessage;
    }

    if (id === "cpfSavingsAccountAmt") {
      input_data.fieldName = "Savings account";
      input_data.fieldVariable = cpfSavingsAccountAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setCpfSavingsAccountAmt(result.value);
        updateRedux("cpfSavingsAccountAmt", result.value, updateInvestmentAsset);
      } else cpfSavingsAccountAmtError = result.errorMessage;
    }

    if (id === "cpfMedisaveAmt") {
      input_data.fieldName = "Medisave account";
      input_data.fieldVariable = cpfMedisaveAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setCpfMedisaveAmt(result.value);
        updateRedux("cpfMedisaveAmt", result.value, updateInvestmentAsset);
      } else cpfMedisaveAmtError = result.errorMessage;
    }

    if (id === "srsAmt") {
      input_data.fieldName = "SRS";
      input_data.fieldVariable = srsAmt;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setSrsAmt(result.value);
        updateRedux("srsAmt", result.value, updateInvestmentAsset);
      } else srsAmtError = result.errorMessage;
    }

    if (id === "investmentPropertyAmt1") {
      input_data.fieldName = "Investment Property 1";
      input_data.fieldVariable = investmentPropertyAmt1;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setInvestmentPropertyAmt1(result.value);
        updateRedux("investmentPropertyAmt1", result.value, updateInvestmentAsset);
      } else investmentPropertyAmtError1 = result.errorMessage;
    }

    if (id === "investmentPropertyAmt2") {
      input_data.fieldName = "Investment Property 2";
      input_data.fieldVariable = investmentPropertyAmt2;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setInvestmentPropertyAmt2(result.value);
        updateRedux("investmentPropertyAmt2", result.value, updateInvestmentAsset);
      } else investmentPropertyAmtError2 = result.errorMessage;
    }

    if (id === "otherInvestmentDesc1") {
      input_data.fieldName = "Other investment 1";
      input_data.fieldVariable = otherInvestmentDesc1;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setOtherInvestmentDesc1(result.value);
        updateRedux("otherInvestmentDesc1", result.value, updateInvestmentAsset);
      } else otherInvestmentDescError1 = result.errorMessage;
    }

    if (id === "otherInvestmentAmt1") {
      input_data.fieldName = "Other investment 1";
      input_data.fieldVariable = otherInvestmentAmt1;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setOtherInvestmentAmt1(result.value);
        updateRedux("otherInvestmentAmt1", result.value, updateInvestmentAsset);
      } else otherInvestmentAmtError1 = result.errorMessage;
    }

    if (id === "otherInvestmentDesc2") {
      input_data.fieldName = "Other investment 2";
      input_data.fieldVariable = otherInvestmentDesc2;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setOtherInvestmentDesc2(result.value);
        updateRedux("otherInvestmentDesc2", result.value, updateInvestmentAsset);
      } else otherInvestmentDescError2 = result.errorMessage;
    }

    if (id === "otherInvestmentAmt2") {
      input_data.fieldName = "Other investment 2";
      input_data.fieldVariable = otherInvestmentAmt2;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setOtherInvestmentAmt2(result.value);
        updateRedux("otherInvestmentAmt2", result.value, updateInvestmentAsset);
      } else otherInvestmentAmtError2 = result.errorMessage;
    }
  }

  function calculateValidity() {
    validAsset = false;

    if (
      otherCashDescError.length !== 0 ||
      otherPersonalAssetsDescError.length !== 0 ||
      otherInvestmentDescError1.length !== 0 ||
      otherInvestmentDescError2.length !== 0
    ) {
      setEnableNext(false);
      return;
    }

    validAsset = true;
    setEnableNext(true);
  }

  return (
    <Grid container spacing={2}>
      <GridSectionHeader
        sectionName="Assets"
        sx={{
          p: 1,
          pl: 1.8,
          mt: 0,
          mb: 1,
          fontSize: 18,
          fontWeight: "bold",
          color: "#FFFFFF", //WHITE
          // color: "#000000", //BLACK
          // backgroundColor: "#d9d9d9",
          backgroundColor: "#10B981",
        }}
      />

      {/* DEMO */}
      {/* <Asset /> */}
      {/* Cash/Near Cash Assets */}
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          Cash/Near Cash <b>Total: ${totalCashAsset}</b>
        </Typography>
      </Grid>

      <GridTextfield
        id="savings"
        key="savings"
        required={false}
        columnSize="6"
        label="Savings"
        currState={savings}
        onChange={handleChange}
        isCurrency={true}
        error={savingsError}
        helperText={savingsError}
      />

      <GridTextfield
        id="fixedDeposit"
        key="fixedDeposit"
        required={false}
        columnSize="6"
        label="Fixed Deposits"
        currState={fixedDeposit}
        onChange={handleChange}
        isCurrency={true}
        error={fixedDepositError}
        helperText={fixedDepositError}
      />

      <GridTextfield
        id="otherCashDesc"
        key="otherCashDesc"
        required={false}
        columnSize="6"
        label="Others (Please describe)"
        currState={otherCashDesc}
        onChange={handleChange}
        error={otherCashDescError}
        helperText={otherCashDescError}
      />

      <GridTextfield
        id="otherCashAmount"
        key="otherCashAmount"
        required={false}
        columnSize="6"
        label="Amount (Others)"
        currState={otherCashAmount}
        onChange={handleChange}
        isCurrency={true}
        error={otherCashAmountError}
        helperText={otherCashAmountError}
      />

      {/* Personal Use Assets */}
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          Personal Use Assets <b>Total: ${totalPersonalUseAsset}</b>
        </Typography>
      </Grid>

      <GridTextfield
        id="residencePropertyAmt"
        key="residencePropertyAmt"
        required={false}
        columnSize="6"
        label="Property - Residence"
        currState={residencePropertyAmt}
        onChange={handleChange}
        isCurrency={true}
        error={residencePropertyAmtError}
        helperText={residencePropertyAmtError}
      />

      <GridTextfield
        id="motorVehiclesAmt"
        key="motorVehiclesAmt"
        required={false}
        columnSize="6"
        label="Motor Vehicle(s)"
        currState={motorVehiclesAmt}
        onChange={handleChange}
        isCurrency={true}
        error={motorVehiclesAmtError}
        helperText={motorVehiclesAmtError}
      />

      <GridTextfield
        id="otherPersonalAssetsDesc"
        key="otherPersonalAssetsDesc"
        required={false}
        columnSize="6"
        label="Others (Eg. Valuables/Collections)"
        currState={otherPersonalAssetsDesc}
        onChange={handleChange}
        error={otherPersonalAssetsDescError}
        helperText={otherPersonalAssetsDescError}
      />

      <GridTextfield
        id="otherPersonalAssetsAmt"
        key="otherPersonalAssetsAmt"
        required={false}
        columnSize="6"
        label="Amount (Others)"
        currState={otherPersonalAssetsAmt}
        onChange={handleChange}
        isCurrency={true}
        error={otherPersonalAssetsAmtError}
        helperText={otherPersonalAssetsAmtError}
      />

      {/* Investment Assets */}
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          Investment Assets <b>Total: ${totalInvestmentAsset}</b>
        </Typography>
      </Grid>

      <GridTextfield
        id="unitTrustAmt"
        key="unitTrustAmt"
        required={false}
        columnSize="6"
        label="Unit Trusts"
        currState={unitTrustAmt}
        onChange={handleChange}
        isCurrency={true}
        error={unitTrustAmtError}
        helperText={unitTrustAmtError}
      />

      <GridTextfield
        id="stocksAmt"
        key="stocksAmt"
        required={false}
        columnSize="6"
        label="Stocks"
        currState={stocksAmt}
        onChange={handleChange}
        isCurrency={true}
        error={stocksAmtError}
        helperText={stocksAmtError}
      />

      <GridTextfield
        id="bondsAmt"
        key="bondsAmt"
        required={false}
        columnSize="6"
        label="Bonds"
        currState={bondsAmt}
        onChange={handleChange}
        isCurrency={true}
        error={bondsAmtError}
        helperText={bondsAmtError}
      />

      <GridTextfield
        id="ilpAmt"
        key="ilpAmt"
        required={false}
        columnSize="6"
        label="ILPs"
        currState={ilpAmt}
        onChange={handleChange}
        isCurrency={true}
        error={ilpAmtError}
        helperText={ilpAmtError}
      />

      <GridTextfield
        id="businessInterestAmt"
        key="businessInterestAmt"
        required={false}
        columnSize="6"
        label="Business Interests"
        currState={businessInterestAmt}
        onChange={handleChange}
        isCurrency={true}
        error={businessInterestAmtError}
        helperText={businessInterestAmtError}
      />

      <GridTextfield
        id="insuranceEndowmentAmt"
        key="insuranceEndowmentAmt"
        required={false}
        columnSize="6"
        label="Insurance Endowment"
        currState={insuranceEndowmentAmt}
        onChange={handleChange}
        isCurrency={true}
        error={insuranceEndowmentAmtError}
        helperText={insuranceEndowmentAmtError}
      />

      <GridTextfield
        id="cpfOriginalAccountAmt"
        key="cpfOriginalAccountAmt"
        required={false}
        columnSize="6"
        label="CPF Balance (OA)"
        currState={cpfOriginalAccountAmt}
        onChange={handleChange}
        isCurrency={true}
        error={cpfOriginalAccountAmtError}
        helperText={cpfOriginalAccountAmtError}
      />

      <GridTextfield
        id="cpfSavingsAccountAmt"
        key="cpfSavingsAccountAmt"
        required={false}
        columnSize="6"
        label="CPF Balance (SA)"
        currState={cpfSavingsAccountAmt}
        onChange={handleChange}
        isCurrency={true}
        error={cpfSavingsAccountAmtError}
        helperText={cpfSavingsAccountAmtError}
      />

      <GridTextfield
        id="cpfMedisaveAmt"
        key="cpfMedisaveAmt"
        required={false}
        columnSize="6"
        label="CPF Medisave (SA)"
        currState={cpfMedisaveAmt}
        onChange={handleChange}
        isCurrency={true}
        error={cpfMedisaveAmtError}
        helperText={cpfMedisaveAmtError}
      />

      <GridTextfield
        id="srsAmt"
        key="srsAmt"
        required={false}
        columnSize="6"
        label="SRS"
        currState={srsAmt}
        onChange={handleChange}
        isCurrency={true}
        error={srsAmtError}
        helperText={srsAmtError}
      />

      <GridTextfield
        id="investmentPropertyAmt1"
        key="investmentPropertyAmt1"
        required={false}
        columnSize="6"
        label="Property - Investments 1"
        currState={investmentPropertyAmt1}
        onChange={handleChange}
        isCurrency={true}
        error={investmentPropertyAmtError1}
        helperText={investmentPropertyAmtError1}
      />

      <GridTextfield
        id="investmentPropertyAmt2"
        key="investmentPropertyAmt2"
        required={false}
        columnSize="6"
        label="Property - Investments 2"
        currState={investmentPropertyAmt2}
        onChange={handleChange}
        isCurrency={true}
        error={investmentPropertyAmtError2}
        helperText={investmentPropertyAmtError2}
      />

      <GridTextfield
        id="otherInvestmentDesc1"
        key="otherInvestmentDesc1"
        required={false}
        columnSize="6"
        label="Other Investments 1"
        currState={otherInvestmentDesc1}
        onChange={handleChange}
        error={otherInvestmentDescError1}
        helperText={otherInvestmentDescError1}
      />

      <GridTextfield
        id="otherInvestmentAmt1"
        key="otherInvestmentAmt1"
        required={false}
        columnSize="6"
        label="Other investment amount 1"
        currState={otherInvestmentAmt1}
        onChange={handleChange}
        isCurrency={true}
        error={otherInvestmentAmtError1}
        helperText={otherInvestmentAmtError1}
      />

      <GridTextfield
        id="otherInvestmentDesc2"
        key="otherInvestmentDesc2"
        required={false}
        columnSize="6"
        label="Other Investments 2"
        currState={otherInvestmentDesc2}
        onChange={handleChange}
        error={otherInvestmentDescError2}
        helperText={otherInvestmentDescError2}
      />

      <GridTextfield
        id="otherInvestmentAmt2"
        key="otherInvestmentAmt2"
        required={false}
        columnSize="6"
        label="Other investment amount 2"
        currState={otherInvestmentAmt2}
        onChange={handleChange}
        isCurrency={true}
        error={otherInvestmentAmtError2}
        helperText={otherInvestmentAmtError2}
      />
    </Grid>
  );
}
